<!--
 * @Description: Description
 * @Author: ranli
 * @Date: 2023-05-18 17:58:19
 * @LastEditTime: 2026-04-14 19:44:26
 * @LastEditors: ranli
-->
<script setup>
import { setPubParams } from 'dad-h5-common-js'
import { getRequestHeader } from './utils/requestheader'
import { useStore } from '@/stores'
// 公共参数
import tokenInfo from './config'
import { removeLoading } from '@/utils/index'
// 是否是开发环境
const isDev = import.meta.env.DEV
const _Store = useStore()
/**
 * 应用是否准备就绪
 */
const isReady = ref(false)
/**
 * 屏幕头部高度
 */
const ScreenHeaderHeight = computed(() => _Store.P_PARAMS.ScreenHeaderHeight || 0)
/**
 * 进入页面
 * @description: 进入页面时，获取公共参数和用户信息
 */
const enterPage = async () => {
  // 开发环境下，直接设置公共参数
  if (isDev) {
    setPubParams(tokenInfo)
    await _Store.SET_P_D(tokenInfo)
    enterApp()
    return
  }
  // 生产环境下，从app获取公共参数
  const p_params = await getRequestHeader()
  setPubParams(p_params)
  await _Store.SET_P_D(p_params)
  enterApp()
}
/**
 * 进入应用
 * @description: 进入应用时，移除loading
 */
const enterApp = () => {
  removeLoading()
  isReady.value = true
  _Store.GET_USERINFO()
  _Store.REFRESH_BALANCE()
}
onMounted(() => {
  enterPage()
})
</script>

<template>
  <van-config-provider>
    <div :style="{
      '--screen-header-height': ScreenHeaderHeight + 'px',
    }">
      <div v-if="isReady" class="cricket-app-inner">
        <router-view />
      </div>
    </div>
  </van-config-provider>
</template>

<style lang="less">
/* global.less */
@import '~/css/public.less';
</style>
